import {capitalize} from 'lodash';
import ShippingInfoStepCardView from '../partials/steps/ShippingInfoStepCardView';
import PersonalInfoStepCardView from '../partials/steps/PersonalInfoStepCardView';
import BrandAssetsStepCardView from '../partials/steps/BrandAssetsStepCardView';
import ContentAgreementStepCardView from '../partials/steps/ContentAgreementStepCardView';
import ProductsStepCardView from '../partials/steps/ProductsStepCardView';
import NetworksStepCardView from '../partials/steps/NetworksStepCardView';
import CompensationStepCardView from '../partials/steps/CompensationStepCardView';
import TasksStepCardView from '../partials/steps/TasksStepCardView';
import UploadFilesStepCardView from '../partials/steps/UploadFilesStepCardView';

export default {
    components: {
        ShippingInfoStepCardView,
        PersonalInfoStepCardView,
        BrandAssetsStepCardView,
        ContentAgreementStepCardView,
        ProductsStepCardView,
        NetworksStepCardView,
        CompensationStepCardView,
        TasksStepCardView,
        UploadFilesStepCardView
    },
    methods: {
        /**
         * Get the component for the given type.
         */
        getComponent(type) {
            return type.split('_')
                    .map(word => capitalize(word))
                    .join('')
                + 'StepCardView'
            ;
        },
    },
};
